<template>
    <div class="search-center">
        <SideNav class="sidenav"></SideNav>
        <div class="search-main">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    import api from '@/api/user'
    import Empty from './empty'
    import SideNav from './SideNav'
    import store from "../../store";

    export default {
        components: {Empty, SideNav},
        methods: {
            getServiceCenterAuthority() {
                api.getServiceCenterAuthority().then(res => {
                    if(!res.all){
                        this.$Message.error('对不起，您暂无查看权限')
                        setTimeout(()=>{
                            this.$router.push(`/records`)
                        },2000)
                    }
                })
            },
            systemNotice() {
                api.systemNotice().then(res => {
                    store.commit('app/setSystemNotice', res)
                })
            }
        },
        mounted() {
            this.getServiceCenterAuthority();
            this.systemNotice();
            document.title='iCourt企业法律服务中台'
        }
    }
</script>
<style lang="scss" scoped>
    .search-center {
    }

    .sidenav {
        left: 0px;
        top: 60px;
        width: 200px;
        bottom: 0px;
        float: left;
        background-color: white;
    }

    /deep/ .ivu-page {
        text-align: center;
    }

    /deep/ .ivu-row {
        min-height: 300px;
    }

    /deep/ .ivu-page-item-active {
        border-color: #ED6C00;

        a {
            color: #ED6C00;
        }
    }

    /deep/ .ivu-page-item {
        &:hover {
            border-color: #ED6C00;

            a {
                color: #ED6C00;
            }
        }
    }

    /deep/ .ivu-page-prev, /deep/ .ivu-page-next {
        &:not(.ivu-page-disabled) {
            &:hover {
                border-color: #ED6C00;

                a {
                    color: #ED6C00;
                }
            }
        }
    }

    /deep/ .ivu-spin-dot {
        background-color: #ED6C00;
    }

    .search-main {
        display: inline-block;
        position: inherit;
        width: calc(100% - 200px);
    }
</style>
